<template>
  <div class="tw-flex" data-testid="workflow-review-status-container">
    <!-- Reviewed but maybe got outdated -->
    <sf-banner-inline
      v-if="reviewed"
      :variant="sfBannerInlineVariant"
      icon-class="fa fa-check"
      :show-icon="hasAnyUpToDateReview"
    >
      <template #title>
        <workflow-review-status-reviewed-by
          :has-any-up-to-date-review="hasAnyUpToDateReview"
          :reviews-to-show="reviewsToShow"
        />
      </template>
      <template #actions>
        <a
          v-if="hasUpToDateReviewByUser"
          class="
            sf-btn sf-btn-primary sf-btn-small sf-btn-inverted
            tw-rounded-md
          "
          :data-heap="`${trackingPrefix}-review-status-mark-as-unreviewed`"
          @click.stop.prevent="unmark"
        >
          <span class="sf-c-text tw-leading-5">{{
            I18n.t('reconciliation_review.unmark')
          }}</span>
        </a>
        <a
          v-else
          :data-heap="`${trackingPrefix}-review-status-mark-as-reviewed`"
          class="
            sf-btn sf-btn-secondary sf-btn-small
            tw-rounded-md
            sf-btn-inverted
          "
          @click.stop.prevent="markAsReviewed"
          >{{ I18n.t('reconciliation_review.mark_as_reviewed') }}</a
        >
      </template>
    </sf-banner-inline>

    <!-- Never reviewed -->
    <a
      v-if="!reviewed"
      :data-heap="`${trackingPrefix}-review-status-mark-as-reviewed`"
      class="sf-btn"
      @click.stop.prevent="markAsReviewed"
      >{{ I18n.t('reconciliation_review.mark_as_reviewed') }}</a
    >
  </div>
</template>

<script>
import SfBannerInline from '@app/shared/vue/components/sf-banner/sf-banner-inline.vue'
import WorkflowReviewStatusReviewedBy from '@app/application/workflows/screens/workflow-review/components/workflow-review-status-reviewed-by.vue'

const WorkflowReviewStatusInline = {
  props: [
    'hasAnyUpToDateReview',
    'hasUpToDateReviewByUser',
    'reviewed',
    'reviewsToShow',
    'trackingPrefix',
  ],
  emits: ['mark-as-reviewed', 'unmark'],
  components: { SfBannerInline, WorkflowReviewStatusReviewedBy },
  computed: {
    sfBannerInlineVariant() {
      return this.hasUpToDateReviewByUser ? 'success' : 'neutral'
    },
  },
  methods: {
    markAsReviewed() {
      this.$emit('mark-as-reviewed')
    },
    unmark() {
      this.$emit('unmark')
    },
  },
}

export default WorkflowReviewStatusInline
</script>
